import {Component, Inject, OnInit, PLATFORM_ID, ViewChild, AfterViewInit} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {VirtualScrollerComponent} from 'ngx-virtual-scroller';
import {ActivatedRoute, Router} from '@angular/router';
import {BrandVm} from '../../view-model/brand/brand.vm';
import {UpdateNavbarEvent} from '../shared/event-listeners/update-navbar/update-navbar.event';
import {ResizeEvent} from '../shared/event-listeners/resize/resize.event';

enum ProviderComponentsEnum {
  SMALL_BANNER = 'SMALL_BANNER',
  HTML_LABEL = 'HTML_LABEL',
  RECT_BANNER = 'RECT_BANNER',
  TWO_RECT_BANNER = 'TWO_RECT_BANNER',
  SHORTCUT_BANNER = 'SHORTCUT_BANNER',
  GRID_BLOG_LIST = 'GRID_BLOG_LIST',
  ITEM_LIST_TWO_ROWS = 'ITEM_LIST_TWO_ROWS',
  VIDEO_LIST = 'VIDEO_LIST',
}

@Component({
  selector: 'app-provider-general',
  templateUrl: './provider-general.component.html',
  styleUrls: ['./provider-general.component.scss'],
})
export class ProviderGeneralComponent implements OnInit, AfterViewInit {
  brand = '';
  nameGroup = '';
  querySend = '';
  property = '';
  gtmList = '';
  providerData;
  providerComponentsEnum = ProviderComponentsEnum;
  isBrowser;
  dataLoaded = false;
  @ViewChild(VirtualScrollerComponent)
  private virtualScroller: VirtualScrollerComponent;
  optionsArrows = true;
  scrollPixel = 0;
  scrollToItem = 0;
  nextItems = 0;
  banners;
  screenSize;
  arrows = {
    left: {
      disabled: true,
      show: true,
    },
    right: {
      disabled: false,
      show: true,
    },
  };

  count = 0;
  loadPage = true;

  constructor(private vm: BrandVm,
              private router: Router,
              private resizeEvent: ResizeEvent,
              private updateNavbarEvent: UpdateNavbarEvent,
              @Inject(PLATFORM_ID) platformId,
              private route: ActivatedRoute) {
                this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);
              }
  ngAfterViewInit(): void {

  }

  ngOnInit(): void {
    this.resizeEvent.currentScreenSize
        .subscribe(screen => {
          this.screenSize = screen;
        });
    this.getBrand();
  }

  reditect(url) {
    this.router.navigateByUrl(url);
  }

  next() {
    if (!this.arrows.right.disabled) {
      this.scrollToItem += this.nextItems;
      this.scrollTo();
    }
  }

  back() {
    if (!this.arrows.left.disabled) {
      this.scrollToItem -= this.nextItems;
      this.scrollTo();
    }
  }

  scrollTo() {
    if (this.virtualScroller) {
      this.virtualScroller.scrollToIndex(this.scrollToItem , null, null, 400, () => {});
    }
  }

  eventScroll(event, list) {
    if (this.optionsArrows && event.endIndex > 0 && list?.length > 0) {
      this.nextItems = event.endIndex + 1;
      this.scrollToItem = event.endIndex;
      this.optionsArrows = false;
    }
    if (event.endIndex > this.nextItems && event.endIndex <= (list?.length - 1)) {
      this.arrows.left.disabled = false;
      this.arrows.right.disabled = false;
    }
    if (event.endIndex === (list?.length - 1)) {
      this.arrows.right.disabled = true;
    }
    if (event.startIndex === 0) {
      this.arrows.left.disabled = true;
    }
  }

  getBrand() {
    const data = {
      provider: 'general',
    };
    this.vm.getBrand(data, this.screenSize).subscribe(res => {
      this.providerData = res.homeSections;
      const banners = res.homeSections.filter(type => type.componentType === 'SMALL_BANNER').pop();
      this.updateNavbarEvent.updateLogo({logo: res.toolbarIcon});
      this.updateNavbarEvent.updateColorNavbar({toolbarBackground: res.toolbarBackground});
      this.banners = banners.list;
      this.dataLoaded = true;
      this.loadPage = false;
    },
    () => {
      this.router.navigate(['']);
    });
  }
}
